import { render, staticRenderFns } from "./TournamentList.vue?vue&type=template&id=268657a0&"
import script from "./TournamentList.vue?vue&type=script&lang=js&"
export * from "./TournamentList.vue?vue&type=script&lang=js&"
import style0 from "./TournamentList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentList.vue"
export default component.exports